import { State } from "../status/Types"
import { ConfigRecord, HardwareConfig } from "../config";

export declare type CallbackWithResult<T> = (error?: Error | null, result?: T | null) => void;
export declare type Callback = (error?: Error | null) => void;
export type NumericString = `${number}`;
export type NumberOrString = `${number}` | number | "";
export type BoolStrings = "TRUE" | "FALSE" | "";
export enum BoolStringShort {
     Y = "Y",
     N = "N",
};
export type VoltageTypes = "AC" | "DC";
export type DateOrString = Date | string | "";
export type UUIDV4 = `${string}-${string}-${string}-${string}-${string}`;
export type TimeString = `${number}:${number}`
// "10f64765-68f5-4fe2-9c83-9CTHERCTSTAT"

export type IconDefinition = string | IconDefinitionObj;

export type IconDefinitionObj = {
    name: string;
    type?: string;
    color?: string;
};

export type PowerInfo = {
    voltage:NumberOrString;
    voltageType:VoltageTypes;
    amps:NumberOrString;
    watts:NumberOrString;
};
export type FuelInfo = {
    fuelType:string;
    btuInput:NumberOrString;
};

/**
 * @deprecated Removed in Catalog v32.
 * @see PortTypeValues
 */
export enum ControlTypes {
    BOTH = "BOTH",
    BUS = "BUS",
    mA = "mA",
    RELAY = "RELAY",
    SERIAL = "SERIAL",
    VALVE = "VALVE",
};

export enum StatusType {
    ENABLED = "ENABLED",
    DISABLED = "DISABLED",
};
export type SetByState = "UNKNOWN" | "API" | "SCHEDULE" | "MONITOR" | "FREEZE_PROTECT" | "READYBY_SCHEDULE" | "LOCAL_UI" | "THEME_MACRO" | "USER" | "ALEXA" | "GOOGLEHOME" | "HOMEKIT" | "BUTTON";
export enum TempControlModes {
    AUTO = "AUTO",
    HEAT = "HEAT",
    COOL = "COOL",
}
export enum HeatingModes {
    SMART = "SMART",
    OFF =  "OFF",
    SOLAR = "SOLAR",
    HEATPUMP = "HEATPUMP",
    FUEL = "FUEL"
};
export enum CoolingModes {
    SMART = "SMART",
    OFF =  "OFF",
    SOLAR = "SOLAR",
    HEATPUMP = "HEATPUMP",
    CHILLER = "CHILLER"
};
export const TemperatureMaintainThreshold = 0.5;
export const TemperatureControlModeChangeThreshold = 5;

export type GasUnits = "ccf" | "gallon" | "ft3" | "m3" | "pound" | "liter" | "kg" | "mj" | "therm";

export enum SaltChlorineDispenseMethods {
    AUTOMATIC_PROBE = "AUTOMATIC_PROBE",
    DAILY_UV_INDEX = "DAILY_UV_INDEX",
    HOURLY_UV_INDEX = "HOURLY_UV_INDEX",
    MANUAL_PERCENT = "MANUAL_PERCENT",
    MANUAL_PPM = "MANUAL_PPM",
};
export type LiquidChlorinatorDispenseMethods = "MANUAL_PPM_DAY" | "AUTOMATIC_PROBE";

/**
 * @todo Clarify if these are "chemical pump types"?
 */
export enum ChemicalType {
    //Unknown = "UNKNOWN",
    MuriaticAcid = "MURIATIC_ACID",
    Chlorine = "CHLORINE",
    Co2 = "CO2",
    Base = "BASE",
};
export const ChemicalTypeSalt = "SALT";

export type ValueAndUnit = {
    value?: any,
    separator?: string,
    unit?: string
}

export enum poolsideSystemComponents {
    MOBILEAPP = "MOBILEAPP",
    LOCALGUI = "LOCALGUI",
};

export enum poolsideEquipmentTypes {
    POOLSIDE = "POOLSIDE",
    POOLSIDE_MINI = "POOLSIDE_MINI",
    POOLSIDE_V2 = "POOLSIDE_BIG_V2",
}

export type CoreParams = {
    configs?: ConfigRecord<any>[],
    /** @deprecated Use configs instead */
    configData?: HardwareConfig,
    /** Key-value pairs as it came from the Controller. (No type fixing: object are seialized, booleans might be strings.") */
    siteStates?: { [ key: string ]: any },
    /** States as it came from the Controller. (No type fixing: object are seialized, booleans might be strings. */
    states?: State[]
}

export type OrgUser = {
    created: Date,
    email: string,
    firstName: string,
    lastName: string,
    userEmail: string,
    userUuid: string,
    uuid: string,
}

export type OrgInvitee = {
    userUuid: null,
    userEmail: string,
    created: string,
    inviter: OrgInviter,
    organization: {
        id: number,
        uuid: string,
        name: string,
    }
}

export type OrgRecord = {
    invitations: OrgInvitee[],
    members: OrgUser[],
    name: string,
    uuid: string,
}

export type OrgInviter = {
    organizations: null,
    invitations: null,
    configs: null,
    agreements: null,
    id: number,
    uuid: string,
    email: string,
    emailConfirmed: boolean,
    firstName: string,
    lastName: string,
    company: null,
    phone: null,
    country: null,
    state: null,
    city: null,
    zip: null,
    address: null,
    thirdPartyId: null,
    language: string,
    dateFormat: string,
    timeFormat: timeFormat,
    tempType: tempType,
    admin: boolean,
    professional: boolean,
    created: string,
    active: number,
    allowRealmSelection: boolean,
    lastSeen: string,
    lastIp: string,
    data: any,
    loadedAt: string,
    originalSeenValue: string,
}

enum timeFormat {
    Hour12 = "12hour",
    Hour24 = "24hour",
}

enum tempType {
    F = "F",
    C = "C",
}

/**
 * 
 */
export enum ContentCategories {
    /** Content everyone should see no matter what */
    BASIC = "BASIC",
    EQUIPMENT_FAILURE = "EQUIPMENT_FAILURE",
    /** E.g: content for guests using a pool of an accomodation (i:e: hotel) through site sharing */
    SHARING = "SHARING",
    SYSTEM_ERROR = "SYSTEM_ERROR",
    SYSTEM_INFO = "SYSTEM_INFO",
    WATER_FLOW = "WATER_FLOW",
    WATER_LEVELING = "WATER_LEVELING",
    WATER_QUALITY = "WATER_QUALITY",
}

export enum BowHistoryMixEvents {
    AcidMix = "AcidMix",
    BaseMix = "BaseMix",
    CO2Mix = "CO2Mix",
    LiquidChlorineMix = "LiquidChlorineMix",
    SaltChlorinatorMix = "SaltChlorinatorMix",
}

export enum gasType {
    Propane = "PROPANE",
    NaturalGas = "NATURALGAS",
}

export const btuPerUnit = {
    [ gasType.Propane ]: {
        "gallon": 91500,
        "ft3": 2488,
        "m3": 87863,
        "pound": 21591,
        "liter": 24000,
        "kg": 46452,
        "mj": 948,
        "therm": 100067
    },
    [ gasType.NaturalGas ]: {
        "gallon": 139050,
        "ft3": 1037,
        "m3": 35310,
        "ccf": 100000,
        "mj": 948,
        "therm": 100067
    }
};

/** Prefix to add for messages intended to see only by R&D */
export const devSign = "DEV";
